import React from "react";
import { Modal } from "antd";
import Magnifier from "react-magnifier";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import NOTFOUNDICON from "../../Assets/not-found.png";

function ImageModalPopup({ imageModalOpen, handleCloseImageModal, Image }) {
  return (
    <Modal
      open={imageModalOpen}
      centered
      onClose={handleCloseImageModal}
      onOk={handleCloseImageModal}
      onCancel={handleCloseImageModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      cancelButtonProps={{ style: { display: "none" } }}
      className="rounded-lg shadow-lg"
      footer={null}
      bodyStyle={{ padding: 0, maxHeight: "90vh", color: "teal" }} // Ensures modal doesn't overflow
    >
      <Box className="p-4 flex flex-col">
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          className="text-center text-xl font-semibold mb-4 color-teal"
          style={{ color: "teal" }}
        >
          Image
        </Typography>
        {Image ? (
          <div className="flex justify-center flex-col">
            <Magnifier
              src={Image}
              mgShape="square"
              alt="Preview"
              className="rounded-lg shadow-md"
              style={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
              }}
            />
            <a
              href={Image}
              className="mt-2 color-teal"
              style={{ color: "teal" }}
            >
              Download Image
            </a>
          </div>
        ) : (
          <div className="flex justify-center mt-4">
            <img src={NOTFOUNDICON} alt="Not Found" className="w-36 h-36" />
          </div>
        )}
      </Box>
    </Modal>
  );
}

export default ImageModalPopup;
